import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { AusstallenUmstallenFrageDialogResult } from './ausstallen-umstallen-frage-dialog';

@Component({
    selector: 'kiene-ausstallen-umstallen-frage-dialog',
    templateUrl: './ausstallen-umstallen-frage-dialog.component.html',
    styleUrls: ['./ausstallen-umstallen-frage-dialog.component.scss'],
})
export class AusstallenUmstallenFrageDialogComponent {
    constructor(public dialogRef: MatDialogRef<AusstallenUmstallenFrageDialogComponent>) {}

    cancel() {
        this.dialogRef.close();
    }

    umstallen() {
        const result = new AusstallenUmstallenFrageDialogResult();
        result.confirmed = true;
        result.result = 'umstallen';
        this.dialogRef.close(result);
    }

    ausstallen() {
        const result = new AusstallenUmstallenFrageDialogResult();
        result.confirmed = true;
        result.result = 'ausstallen';
        this.dialogRef.close(result);
    }
}
